import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    accountTypeId: null,
    portfolioData: null,
    currentPortfolioRow: null,
    selectedClientTab: "profile",
};

const portfolioSlice = createSlice({
    name: "portfolio",
    initialState,
    reducers: {
        setAccountTypeId: (state, action) => {
            state.accountTypeId = action.payload;
        },
        setPortfolioData: (state, action) => {
            state.portfolioData = action.payload;
        },
        setCurrentPortfolioRow: (state, action) => {
            state.currentPortfolioRow = action.payload;
        },
        setSelectedClientTab: (state, action) => {
            state.selectedClientTab = action.payload;
        },
        clearPortfolioData: (state) => {
            state.accountTypeId = null;
            state.portfolioData = null;
            state.currentPortfolioRow = null;
        },
    },
});

export const {
    setAccountTypeId,
    setPortfolioData,
    setCurrentPortfolioRow,
    setSelectedClientTab,
    clearPortfolioData
} = portfolioSlice.actions;

// Selectors
export const selectAccountTypeId = (state) => state.portfolio.accountTypeId;
export const selectPortfolioData = (state) => state.portfolio.portfolioData;
export const selectCurrentPortfolioRow = (state) => state.portfolio.currentPortfolioRow;

export default portfolioSlice.reducer;
